import {AbstractControl, ValidatorFn} from '@angular/forms';
import moment from 'moment';

/**
 * validator to check if control value is equal or next to another date
 * @param previousDate
 */
export function dateAfterValidator(previousDate: AbstractControl): ValidatorFn {
  return (control: AbstractControl): { [key: string]: {date: string} } | null => {
    if (previousDate.value && moment(control.value).isBefore(moment(previousDate.value))) {
      return {dateAfter: {date: moment(previousDate.value).format('DD/MM/YYYY')}};
    }
    return null;
  };
}
